import { skipToken } from "@reduxjs/toolkit/query";
import { useSelector } from "react-redux";

import { selectProfileSSOid } from "../../app-main/selectors/profile.selectors";
import type { OwnerSpace } from "../../services/spaces.service";
import { useGetOwnerSpacesQuery } from "../../services/spaces.service";

type UseHostHubOwnerSpacesResult = {
  isError: boolean;
  isLoading: boolean;
  spaces: OwnerSpace[] | undefined;
};

/**
 * Shared accessor for the authenticated host's spaces (titles + images) from
 * `GET /v1/spaces/owner/:sso-id?full=true`. Recommendation hooks consume this
 * so the owner-spaces fetch is declared once and reused via RTK Query's cache.
 */
const useHostHubOwnerSpaces = (): UseHostHubOwnerSpacesResult => {
  const ssoId = useSelector(selectProfileSSOid);

  const ownerSpacesQuery = useGetOwnerSpacesQuery(
    ssoId ? { ssoId } : skipToken,
  );

  return {
    isError: ownerSpacesQuery.isError,
    isLoading: ownerSpacesQuery.isLoading,
    spaces: ownerSpacesQuery.data?.spaces,
  };
};

export default useHostHubOwnerSpaces;
